export default "__VITE_ASSET__36d23caa__"